import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const currentLang = i18n.language;
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams();


  const handleLanguageChange = (newLang) => {
    if (newLang === lang) return; // nič sa nemení

    const newPath = location.pathname.replace(/^\/(en|sk|cz)/, `/${newLang}`);
    i18n.changeLanguage(newLang).then(() => {
      navigate(newPath);
    });
  };
  
  const getFlagImage = (lang) => {
    switch (lang) {
      case 'en':
        return `${process.env.PUBLIC_URL}/en_EN.png`;
      case 'sk':
        return `${process.env.PUBLIC_URL}/sk_SK.png`;
      case 'cz':
      case 'cs':
        return `${process.env.PUBLIC_URL}/cz_CZ.png`;
      default:
        return `${process.env.PUBLIC_URL}/en_EN.png`;
    }
  };

  // Zavrie dropdown po kliknutí mimo
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`dropdown ${open ? 'show' : ''}`} ref={dropdownRef}>
      <button
        className="btn btn-light btn-icon mb-0 mx-0 dropdown-toggle"
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <img
          src={getFlagImage(currentLang)}
          alt={currentLang}
          width="24"
          height="24"
          className="rounded-circle mx-1"
        />
      </button>
      <ul className={`dropdown-menu dropdown-menu-end ${open ? 'show' : ''}`} aria-labelledby="languageDropdown">
        <li>
          <button
            className="ms-0 dropdown-item d-flex align-items-center"
            onClick={() => handleLanguageChange('en')}
          >
            <img src={`${process.env.PUBLIC_URL}/en_EN.png`} alt="English" width="24" height="24" className="me-2" />
            English
          </button>
        </li>
        <li>
          <button
            className="ms-0 dropdown-item d-flex align-items-center"
            onClick={() => handleLanguageChange('sk')}
          >
            <img src={`${process.env.PUBLIC_URL}/sk_SK.png`} alt="Slovak" width="24" height="24" className="me-2" />
            Slovak
          </button>
        </li>
        <li>
          <button
            className="ms-0 dropdown-item d-flex align-items-center"
            onClick={() => handleLanguageChange('cz')}
          >
            <img src={`${process.env.PUBLIC_URL}/cz_CZ.png`} alt="Czech" width="24" height="24" className="me-2" />
            Czech
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSwitcher;
